import './index.css'
import useRateResolver from './useRateResolver';
import TestimonialsGrid from './TestimonialsGrid';
import PricingAutomation from './PricingAutomation';
import TrustedBy from './TrustedBy';
import BlogSection from './BlogSection';
import { useLocation, useNavigate } from "react-router";

const FuturePage = () => {
    const {
        CONTRACT, PLAN_LABEL, showExpo, expoStripVisible, setExpoStripVisible,
        prop, setProp, date, setDate, plan, setPlan, ad, ch, ages,
        handleAdChange, handleChChange, handleAgeChange,
        c, season, adultRate, adSub, childRows, festiveRow, total
    } = useRateResolver();

    const navigate = useNavigate();

    const scrollToTop = (value) => {
        navigate('/' + value);
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // Optional: for smooth scroll animation
        });
    };
    return (
        <>
            <div className='body-div'>

                <PricingAutomation />

                <section className="tw3-proof">
                    <div className="wrap">

                        {/* 1 - MAIN testimonial */}
                        <div className="tw3-main">
                            <div className="tw3-by tw3-by-top">
                                <img className="tw3-avatar" src="./img/GlenRawlings.jpg" alt="Glen Rawlings" />
                                <div>
                                    <div className="tw3-by-name">Glen Rawlings</div>
                                    <div className="tw3-by-role">Managing Director, Southern Cross Safaris — Mombasa, Kenya</div>
                                </div>
                            </div>

                            <div className="tw3-points">
                                <div className="tw3-point">
                                    <span className="tw3-bullet"></span>
                                    <p className="tw3-point-text tw3-point-first">
                                        The system understands our lodge contracts the way our best reservations consultants do.
                                    </p>
                                </div>

                                <div className="tw3-point">
                                    <span className="tw3-bullet"></span>
                                    <p className="tw3-point-text">
                                        What used to take hours now takes minutes, which means we respond to agent enquiries faster and convert more bookings.
                                    </p>
                                </div>

                                <div className="tw3-point">
                                    <span className="tw3-bullet"></span>
                                    <p className="tw3-point-text">
                                        It is not software we use occasionally. It is the system our entire business runs on.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* 2 and 3 */}
                        <div className="tw3-row">

                            <div className="tw3-card tw3-card-amber">

                                <div className="tw3-by">
                                    <img className="tw3-avatar" src="./img/monicasolankiimage.jpeg" alt="Monica Solanki" />
                                    <div>
                                        <div className="tw3-by-name">Monica Solanki</div>
                                        <div className="tw3-by-role">Owner, Lofty Tours, Mombasa</div>
                                    </div>
                                </div>
                                <p className="tw3-card-text">
                                    <strong className="tw3-brand">Twigaa</strong> gave a small operation like ours the capability of a much larger one.
                                </p>

                            </div>

                            <div className="tw3-card">
                                <div className="tw3-by">
                                    <img className="tw3-avatar" src="./img/naturesurf.jpeg" alt="Catherine" />
                                    <div>
                                        <div className="tw3-by-name">Catherine</div>
                                        <div className="tw3-by-role">GM, Nature Surf Africa Safaris</div>
                                    </div>
                                </div>
                                <p className="tw3-card-text">
                                    Thanks to <strong className="tw3-brand">Twigaa.ai</strong>, we've not only improved efficiency but also enhanced the overall travel experience for our clients. Highly recommend!
                                </p>

                            </div>

                        </div>
                    </div>
                </section>

                <section id="problems">
                    <div className="wrap">
                        <div className="section-head">
                            <h2>You've said at least one of these out loud this season.</h2>
                        </div>
                        <div className="problems">
                            <div className="problem">
                                <q>We quoted it wrong, and now it's too late to fix.</q>
                                <p>A missed shoulder-season rate or a supplement fee — and the margin is gone before anyone realizes it.</p>
                            </div>
                            <div className="problem">
                                <q>Entering contract rates eats weeks, sometimes months, of my team's time.</q>
                                <p>The reservations team stops selling and starts doing data entry and double-checking pricing instead.</p>
                            </div>
                            <div className="problem">
                                <q>No two people calculate the same price for a given child policy.</q>
                                <p>Three adults and two children — one of them a youth — in a family room at a given hotel: ask three consultants, and you'll get three different rates.</p>
                            </div>
                            <div className="problem">
                                <q>Only one person actually knows the rates.</q>
                                <p>The rules live in someone's head and a spreadsheet they maintain. When they're on leave, quoting slows to a crawl — and when they leave for good, it's worse.</p>
                            </div>
                            <div className="problem">
                                <q>Too many systems are killing our productivity.</q>
                                <p>One tool for CRM, another for itineraries, another for accounts, another for vouchers — it's driving us crazy, and we end up spending half our time just keeping them all in sync. There's no single source of truth.</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="doors">
                    <div className="wrap">
                        <div className="section-head" style={{ marginBottom: "46px" }} >
                            <p className="eyebrow">Two ways in</p>
                            <h2>Replace the stack Twigaa OS or kept it and use our propreitary Oxpecker + Weaver</h2>
                        </div>

                        <div className="doors">
                            <div className="door a">
                                <span className="who">For operators ready to consolidate</span>
                                <h2>The complete Twigaa OS</h2>
                                <p>One system from enquiry to invoice. Lead capture, costing, itinerary, vouchers and finance share the same data, so a rate change reaches the quote, the voucher and the ledger at once.</p>
                                <ul className="modules">
                                    <li>Connected CRM — leads from every channel, tracked to closure</li>
                                    <li>Auto-costing on your contract rates, your seasons, your markup</li>
                                    <li>Itinerary builder — lead to digital itinerary in under five minutes</li>
                                    <li>Hotel and vehicle vouchers, invoices, and finance</li>
                                    <li>White-labelled on your own domain</li>
                                </ul>
                                <div className="btn-row text-dark">
                                    <a className="btn btn-solid"
                                        onClick={() =>
                                            window.gtag_report_conversion()
                                        }
                                        href="https://forms.gle/GsaFJ4kCVUuUEftq5"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >See the full platform →</a>
                                </div>
                            </div>

                            <div className="door b">
                                <span className="who">For operators who won't switch tools</span>
                                <h2>Oxpecker + Weaver</h2>
                                <p>Already invested in Wetu, SafariOffice or Tourplan? Keep them. Take only the rate engine and feed exact numbers back into whatever you already use.</p>

                                <div className="prod">
                                    <span className="prod-name">Oxpecker</span>
                                    <span className="prod-role">AI contract extraction</span>
                                </div>
                                <p>Send us the contract PDF. It comes back as a structured rate grid — seasons, room types, meal plans, child policies, festive supplements — verified before it goes live.</p>

                                <div className="prod">
                                    <span className="prod-name">Weaver</span>
                                    <span className="prod-role">Rate compiler &amp; engine</span>
                                </div>
                                <p>Those grids compile into a queryable engine. Ask for a hotel, dates, pax and plan; get the exact rate with the rules that produced it. Log in, or call the API.</p>

                                <div className="btn-row">
                                    <a className="btn btn-amber text-dark"
                                        onClick={() =>
                                            window.gtag_report_conversion()
                                        }
                                        href="https://forms.gle/i66tDJwmMPapiLaW8"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Get Oxpecker + Weaver →</a>
                                </div>
                            </div>
                        </div>

                        <div className="resolver" id="resolver">
                            <div className="resolver-top">
                                <span>ratescript · resolve()</span>
                                <span className="tag">sample contract — demo data</span>
                            </div>
                            <div className="resolver-body">
                                <div className="controls">
                                    <div className="field">
                                        <label for="prop">Property</label>
                                        <select id="prop" value={prop} onChange={(e) => setProp(e.target.value)}>
                                            {Object.entries(CONTRACT).map(([k, v]) => (
                                                <option key={k} value={k}>{v.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="field">
                                        <label for="date">Check-in date</label>
                                        <input type="date" id="date" value={date} min="2026-01-01" max="2026-12-31" onChange={(e) => setDate(e.target.value)} />
                                    </div>
                                    <div className="field">
                                        <label for="plan">Meal plan</label>
                                        <select id="plan" value={plan} onChange={(e) => setPlan(e.target.value)}>
                                            <option value="BB">Bed &amp; breakfast</option>
                                            <option value="HB">Half board</option>
                                            <option value="FB">Full board</option>
                                        </select>
                                    </div>
                                    <div className="pax">
                                        {/* Adults Field */}
                                        <div className="field">
                                            <label htmlFor="ad">Adults</label>
                                            <div className="stepper">
                                                <button type="button" aria-label="Fewer adults" onClick={() => handleAdChange(-1)}>−</button>
                                                <output id="ad">{ad}</output>
                                                <button type="button" aria-label="More adults" onClick={() => handleAdChange(1)}>+</button>
                                            </div>
                                        </div>

                                        {/* Children Field */}
                                        <div className="field">
                                            <label htmlFor="ch">Children</label>
                                            <div className="stepper">
                                                <button type="button" aria-label="Fewer children" onClick={() => handleChChange(-1)}>−</button>
                                                <output id="ch">{ch}</output>
                                                <button type="button" aria-label="More children" onClick={() => handleChChange(1)}>+</button>
                                            </div>
                                            {/* Dynamically render age dropdowns based on the child count */}
                                            <div className="ages" id="ages">
                                                {ages.map((age, i) => (
                                                    <select key={i} value={age} onChange={(e) => handleAgeChange(i, e.target.value)}>
                                                        {Array.from({ length: 18 }, (_, a) => (
                                                            <option key={a} value={a}>{a} yr</option>
                                                        ))}
                                                    </select>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="trace" id="trace" aria-live="polite">
                                    <div className="trace-row"><span>contract</span><b>{c.name}</b></div>
                                    <div className="trace-row"><span>date resolves to</span><b className="rule">{season.label} season</b></div>
                                    <div className="trace-row"><span>plan</span><b>{PLAN_LABEL[plan]}</b></div>
                                    <hr />
                                    <div className="trace-row"><span>{ad} × adult @ {c.cur} {adultRate}</span><b>{c.cur} {adSub}</b></div>

                                    {childRows.map((cr) => (
                                        <div key={cr.id} className="trace-row">
                                            <span>{cr.label} — <span className="rule">{cr.note}</span></span>
                                            <b>{c.cur} {cr.amt}</b>
                                        </div>
                                    ))}

                                    {festiveRow && (
                                        <div className="trace-row">
                                            <span className="warn">supplement — {festiveRow.note}</span>
                                            <b>{c.cur} {festiveRow.amt}</b>
                                        </div>
                                    )}

                                    <hr style={{ marginTop: 'auto' }} />
                                    <div className="total">
                                        <span>Total per night</span>
                                        <strong>{c.cur} {total.toLocaleString()}</strong>
                                    </div>
                                </div>
                            </div>
                            <div className="resolver-foot">Illustrative contract data. Your own rates resolve the same way — through your contracts, not ours.</div>
                        </div>

                        <div className="chips">
                            <span className="lbl">Works alongside</span>
                            <span className="chip">Wetu</span>
                            <span className="chip">SafariOffice</span>
                            <span className="chip">Travelyst</span>
                            <span className="chip">Tourplan</span>
                            <span className="chip">Your own spreadsheets</span>
                        </div>
                    </div>
                </section>

                <TestimonialsGrid />

                <TrustedBy />

                <BlogSection />

                {showExpo && (
                    <section className="expo" id="expo">
                        <div className="wrap">
                            <div className="expo-card">
                                <p className="expo-kicker">Meet us in person</p>
                                <h2>Twigaa is landing at Magical Kenya 2026</h2>
                                <p className="sub">Experience how Twigaa is transforming tour operations across Africa — now expanding from East to Southern Africa.</p>
                                <hr className="expo-rule" />
                                <div className="expo-grid">
                                    <div className="expo-plate"><img src="./img/mkte_logo_extracted.png" alt="Magical Kenya Travel Expo" /></div>
                                    <div className="expo-facts">
                                        <div className="fact">
                                            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s7-6.1 7-11a7 7 0 1 0-14 0c0 4.9 7 11 7 11Z" /><circle cx="12" cy="10" r="2.6" /></svg>
                                            <span>Nairobi, Kenya</span>
                                        </div>
                                        <div className="fact">
                                            <svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.5" y="5" width="17" height="15.5" rx="2.5" /><path d="M3.5 9.6h17M8 3v4M16 3v4" /></svg>
                                            <span>6 – 8 October 2026</span>
                                        </div>
                                        <div className="fact">
                                            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20V11l8-6.5L20 11v9z" /><path d="M9.5 20v-5.2h5V20" /></svg>
                                            <span>Stall A15</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-row">
                                    <a className="btn btn-amber text-dark"
                                        onClick={() =>
                                            window.gtag_report_conversion()
                                        }
                                        href="https://forms.gle/eGjJvF7DgLsmaLPLA"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >Book a meeting →</a>
                                </div>
                                <p className="expo-note">Diaries fill early — slots are held on a first-come basis.</p>
                            </div>
                        </div>
                    </section>
                )}

                <section className="final">
                    <div className="wrap">
                        <p className="eyebrow">Pick your door</p>
                        <h2>Start where it hurts most.</h2>
                        <p className="lede">Take the whole platform, or take the rates and leave the rest of your stack alone. Either way the first conversation is the same.</p>
                        <div className="btn-row">
                            <a className="btn btn-solid text-dark"
                                onClick={() =>
                                    window.gtag_report_conversion()
                                }
                                href="https://forms.gle/GsaFJ4kCVUuUEftq5"
                                target="_blank"
                                rel="noopener noreferrer"
                            >See the full platform →</a>
                            <a className="btn btn-amber text-dark"
                                onClick={() =>
                                    window.gtag_report_conversion()
                                }
                                href="https://forms.gle/i66tDJwmMPapiLaW8"
                                target="_blank"
                                rel="noopener noreferrer"
                            >Get standalone access →</a>
                        </div>
                        <p style={{ marginTop: "26px", fontSize: ".86rem", color: "var(--muted)" }}>
                            Prefer to see numbers first? <a onClick={() => scrollToTop('pricing-plans')} style={{ color: "var(--green)", cursor: "pointer" }}>Pricing</a>
                        </p>
                    </div>
                </section>
            </div>
        </>
    )
}
export default FuturePage